export const DEFAULT_API_TIMEOUT_MS = 15000
export const LOCAL_API_TIMEOUT_MS = 600000

export const isLocalApiHost = (hostname = '') => ['localhost', '127.0.0.1', '[::1]'].includes(hostname)

// Allow ten minutes on localhost, including compiled builds used for local QA.
// Production limits and explicitly disabled timeouts retain their values.
export function resolveApiTimeout(options = {}, localRuntime = false) {
  const timeout = Object.prototype.hasOwnProperty.call(options, 'timeoutMs')
    ? options.timeoutMs
    : DEFAULT_API_TIMEOUT_MS
  return localRuntime && typeof timeout === 'number' && timeout > 0
    ? Math.max(timeout, LOCAL_API_TIMEOUT_MS)
    : timeout
}
